export default __webpack_public_path__ + "static/media/one.a13d8399.jpg";